export const FETCH_STORAGE_SPACE = 'FETCH_STORAGE_SPACE';
export const SETUP_ARCHIVE_PASSWORD = 'SETUP_ARCHIVE_PASSWORD';
export const RESET_ARCHIVE_PASSWORD_STATUS = 'RESET_ARCHIVE_PASSWORD_STATUS';
export const DELETE_ARCHIVE = 'DELETE_ARCHIVE';
export const RESET_ARCHIVE_DELETION_STATUS = 'RESET_ARCHIVE_DELETION_STATUS';
export const FETCH_CONTENT_ITEMS = 'FETCH_CONTENT_ITEMS';
export const SEARCH_CONTENT_ITEMS = 'SEARCH_CONTENT_ITEMS';
export const UPDATE_ACTIVE_CONTENT_TYPE = 'UPDATE_ACTIVE_CONTENT_TYPE';
export const FETCH_FILE_VERSIONS = 'FETCH_FILE_VERSIONS';
export const SIGN_FILE = 'SIGN_FILE';
export const RESET_SIGN_FILE_STATUS = 'RESET_SIGN_FILE_STATUS';
export const UPDATE_ACTIVE_VERSION_PATH = 'UPDATE_ACTIVE_VERSION_PATH';
export const UPDATE_ACTIVE_VOLUME_PATH = 'UPDATE_ACTIVE_VOLUME_PATH';
export const SORT_CONTENT_ITEMS = 'SORT_CONTENT_ITEMS';
export const FETCH_CONTAINER_ITEMS = 'FETCH_CONTAINER_ITEMS';
export const UPDATE_ACTIVE_MACHINE = 'UPDATE_ACTIVE_MACHINE';
export const FETCH_MACHINE_BACKUPS = 'FETCH_MACHINE_BACKUPS';
export const UPDATE_ACTIVE_BACKUP = 'UPDATE_ACTIVE_BACKUP';
export const FETCH_WR_CONFIG = 'FETCH_WR_CONFIG';
export const DELETE_ALL_INCOMPLETE_BACKUPS = 'DELETE_ALL_INCOMPLETE_BACKUPS';
